export const HEBREW_VOICE_AUDIO_CONTROL_GUIDANCE = `

🔊 בקשות על עוצמת הקול - הקשר אקוסטי בלבד:
מילים כמו "להנמיך אותך", "תדברי חלש יותר", "להגביר", "חזק יותר" או "עוצמת הקול" מתייחסות לשמע ולא לאופן הפנייה הדקדוקי ללקוח.
אין לקשר בקשת שמע ללשון יחיד/רבים, זכר/נקבה או לכלל הפנייה ללקוח, ואין להסביר את מצב הפנייה אלא אם הלקוח שאל במפורש על לשון הפנייה.
אין לך שליטה ישירה בעוצמת ההשמעה במכשיר או בדפדפן, ולכן אסור לטעון שהנמכת או הגברת את הקול.
אם מבקשים להנמיך או להגביר, עני בקצרה ובהקשר: "אין לי אפשרות לשנות את עוצמת השמע מתוך השיחה. אפשר להנמיך או להגביר דרך כפתורי הווליום במכשיר." לאחר מכן המתיני לתשובת הלקוח ואל תדלגי לנושא עסקי חדש.`

